import axiosInstance from "./instance";

// Get All Vendors by Status
const fetchTickets = async (page, status, limit = 15) => {
    const response = await axiosInstance.get('/tickets', {
        params: {
            page,
            limit,
            status
        }
    });
    return response.data;
}

// Get Solo Order Details
const fetchTicket = async (ticketId) => {
    const response = await axiosInstance.get(`/tickets/${ticketId}`);
    return response.data;
}

const updateTicket = async (ticketId, status) => {
    const response = await axiosInstance.patch(`/tickets/${ticketId}`, {
        isResolved: status === true || status === 'true'
    });
    return response.data;
}

// const updatefeature = async (ticketId, status) => {
//     const response = await axiosInstance.post('/vendor/feature', {
//         ticketId,
//         status
//     });
//     console.log(response.data);
//     return response.data;
// }

export { fetchTickets, fetchTicket, updateTicket, };
